<template>
  <v-app id="login">
    <v-content>
      <v-container fluid fill-height>
        <v-layout row wrap align-center justify-center>
          <v-flex xs6 sm8 md4 class="hide">
            <h1
              class="animate__animated animate__fadeInDownBig vertical-center"
            >
              AI - CXR SCREENING
            </h1>
            <div elevation="12">
              <v-img class="mt-12" src="../assets/ai.png" height="450"></v-img>
            </div>
          </v-flex>

          <v-flex xs12 sm8 md4>
            <div :class="['hide', 'd-flex', $vuetify.breakpoint.smAndUp ? 'mt-n10':'']" style="justify-content: end;">
              <div class="vertical-right">
                <v-img src="../assets/icon.png"></v-img>
              </div>
            </div>
            <v-card
              class="pt-12 px-8 pb-3"
              max-width="1100"
              elevation="2"
              tile
            >
              <v-img
                src="../assets/1Life.png"
                style="width: 51%"
                class="pic_none"
              ></v-img>
              <v-form ref="form_login">
                <v-text-field
                  prepend-icon="mdi-account"
                  label="Username"
                  v-model="form_login.username"
                  :rules="usernameRules"
                >
                </v-text-field>

                <v-text-field
                  prepend-icon="mdi-lock"
                  label="Password"
                  v-model="form_login.password"
                  :rules="passwordRules"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show1 ? 'text' : 'password'"
                  @click:append="show1 = !show1"
                  @keyup.enter="login()"
                ></v-text-field>

                <!-- <v-card-actions class="align-center justify-center">
                  <v-checkbox v-model="checkbox"></v-checkbox>
                  <span>
                    I agree to the
                    <U style="cursor:pointer"> term of service </U> :
                    {{ checkbox.toString() }}
                  </span>
                </v-card-actions> -->
              </v-form>
              <v-checkbox v-model="accept_fmr">
                <template v-slot:label>
                  <div class="text-fmr">
                    รับทราบ
                    <a
                      @click.stop
                      target="_blank"
                      style="text-decoration: none;"
                      href="https://manageai.co.th/static/pdf/Policy_manageAi.pdf"
                      >เงื่อนไขการให้บริการ</a
                    >
                    ,&nbsp;
                    <a
                      @click.stop
                      target="_blank"
                      style="text-decoration: none;"
                      href="https://manageai.co.th/static/pdf/Manage_AI_PDPA.pdf"
                      >นโยบายคุ้มครองข้อมูลส่วนบุคคล</a
                    >
                    และ
                    <a
                      @click.stop
                      target="_blank"
                      style="text-decoration: none; white-space: nowrap;"
                      href="https://manageai.co.th/static/pdf/discliamer.pdf"
                      >ข้อจำกัดความรับผิดชอบ</a
                    >
                  </div>
                </template>
              </v-checkbox>
              <v-card-actions class="align-center justify-center mb-2">
                  <v-btn
                    rounded
                    :disabled="!accept_fmr"
                    :dark="accept_fmr"
                    color="pink"
                    width="90%"
                    @click="login()"
                  >
                    Login
                  </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>

          <!-- snackbar -->
          <div class="text-center ma-2">
            <v-snackbar v-model="snackbar">
              {{ text }}
              <template v-slot:action="{ attrs }">
                <v-btn color="pink" v-bind="attrs" @click="snackbar = false">
                  Close
                </v-btn>
              </template>
            </v-snackbar>
          </div>
        </v-layout>
      </v-container>
    </v-content>
    <!-- </v-main> -->

    <!-- dialog-announcement -->
    <div class="text-center">
      <v-dialog v-model="dialog_announcement" max-width="600" persistent>
        <v-card>
          <v-card-title class="headline red lighten-2">
            <v-icon style="color:white">mdi-message-alert-outline</v-icon>
            <span class="ml-2" style="color:white"> Announcement</span>
          </v-card-title>

          <v-card-text style="text-align:center">
            <br />
            <v-icon style="font-size:60px;color:red">mdi-traffic-cone</v-icon>
            <br />
            <br />
            <span style="font-size:16px"> แจ้งเพื่อทราบ </span>
            <br />
            <span style="font-size:15px"> {{ check_announcement.data }}</span>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" text @click="dialog_announcement = false">
              I accept
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-app>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      checkbox: false,
      response: [],
      dialog_announcement: "",
      dialog_consent: "",
      check_announcement: "",
      show1: false,
      accept_fmr: false,
      //snackbar
      snackbar: false,
      text: "",
      timeout: 5000,
      form_consent: {
        username: "",
        password: "",
        consent: ""
      },
      form_login: {
        username: "",
        password: ""
      },
      usernameRules: [v => !!v || "Username is required"],
      passwordRules: [v => !!v || "Password is required"]
    };
  },
  mounted() {
    localStorage.clear();
    this.before_login();
    this.$cookies.remove("info_login");
    this.$cookies.remove("service");
  },

  methods: {
    before_login() {
      this.axios
        .get(process.env.VUE_APP_API + "/api/v3/announcement/geTLoginannounce")
        .then(response => {
          this.check_announcement = response.data;
          if (this.check_announcement.status_ann) {
            this.dialog_announcement = true;
          }
        })
        .catch(error => {
          console.log("error", error);
        });
    },

    login() {
      console.log(this.form_login);
      if (!this.$refs.form_login.validate()) {
        return;
      } else {
        this.axios
          .post(
            process.env.VUE_APP_API + "/api/v3/authenticate",
            this.form_login
          )
          .then(response => {
            console.log("response", response.data.package_use);
            console.log("response_info", response);
            if (response.data.status === "fail") {
              this.snackbar_alert(response.data.message);
              return;
            } else if (
              //////////////////////// role ==> superadmin  ////////////////////////////
              response.data.status === "pass" &&
              response.data.data.role === "superadmin"
            ) {
              this.$cookies.set("info_login", response.data.data);
              // เงื่อนไข consent แต่ปิดไว้อยุ่
              if (response.data.data.consent == false) {
                this.$router.push("/consent");
              } else {
                // ==== >   api < ==== //
                window.location.href =
                  process.env.VUE_APP_API + "/cxrmanageuser/management/user";
              }
              // ==== >   api < ==== //
              // window.location.href =
              //   process.env.VUE_APP_API + "/cxrmanageuser/management/user";
            } else if (
              //////////////////////// role ==> user  ////////////////////////////
              response.data.status === "pass" &&
              response.data.data.role === "user"
            ) {
              console.log("user");
              this.$cookies.set("info_login", response.data.data);
              this.$cookies.set("service", response.data);
              console.log("service", this.$cookies.get("service"));
              // ตรวจสอบเงื่อนไข consent ก่อนเข้าใช้งาน
              if (response.data.data.consent == false) {
                this.$router.push("/consent");
              } else {
                if (response.data.package_use.length < 2) {
                  console.log(1);
                  if (response.data.package_use == "cxr") {
                    console.log("cxr-check");
                    localStorage.setItem(
                      "service",
                      JSON.stringify(response.data.package_use)
                    );
                    localStorage.setItem("service_name", "CXR");
                    // ==== >   api < ==== //
                    window.location.href =
                      process.env.VUE_APP_API + "/cxrservice/upload";
                  } else if (response.data.package_use == "retina") {
                    console.log("ratina-check");
                    localStorage.setItem(
                      "service",
                      JSON.stringify(response.data.package_use)
                    );
                    localStorage.setItem("service_name", "RATINA");
                    // ==== >   api < ==== //
                    window.location.href =
                      process.env.VUE_APP_API + "/retinaservice/upload";
                  }
                } else {
                  console.log("please choose service");
                  localStorage.setItem(
                    "service",
                    JSON.stringify(response.data.package_use)
                  );
                  this.$router.push("/service");
                }
              }
            } else if (
              //////////////////////// role ==> Viewer  ////////////////////////////
              response.data.status === "pass" &&
              response.data.data.role === "viewer"
            ) {
              console.log("viewer");
              this.$cookies.set("info_login", response.data.data);
              this.$cookies.set("service", response.data);
              // ตรวจสอบเงื่อนไข consent ก่อนเข้าใช้งาน
              if (response.data.data.consent == false) {
                this.$router.push("/consent");
              } else {
                console.log("service", this.$cookies.get("service"));
                if (response.data.package_use.length < 2) {
                  console.log(1);
                  if (response.data.package_use == "cxr") {
                    console.log("cxr-check");
                    localStorage.setItem(
                      "service",
                      JSON.stringify(response.data.package_use)
                    );
                    localStorage.setItem("service_name", "CXR");
                    // ==== >   api < ==== //
                    window.location.href =
                      process.env.VUE_APP_API + "/cxrservice/history";
                  } else if (response.data.package_use == "retina") {
                    console.log("ratina-check");
                    localStorage.setItem(
                      "service",
                      JSON.stringify(response.data.package_use)
                    );
                    localStorage.setItem("service_name", "RATINA");
                    // ==== >   api < ==== //
                    window.location.href =
                      process.env.VUE_APP_API + "/retinaservice/history";
                  }
                } else {
                  console.log("please choose service");
                  localStorage.setItem(
                    "service",
                    JSON.stringify(response.data.package_use)
                  );
                  this.$router.push("/service");
                }
              }
            }
          })
          .catch(error => {
            console.log("error", error);
          });
      }
    },

    snackbar_alert(error_msg) {
      this.snackbar = true;
      this.text = error_msg;
      this.timeout;
      console.log("snackbar_alert");
    }
  },
  sockets: {
    connect: function() {
      console.log("socket connected");
    },
    test: function(data) {
      console.log("data", data);
    }
  }
};
</script>

<style>
.text-fmr {
  color: black;
  text-align: center;
  font-size: 14px;
}
.vertical-center {
  animation-duration: 1.25s;
  margin: 0;
  position: absolute;
  top: 20%;
  left: 17%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.vertical-suggest {
  animation-duration: 2.75s;
  margin: 0;
  position: absolute;
  top: 75%;
  left: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.vertical-right {
  animation-duration: 1.25s;
  margin-bottom: 4%;
  width: 40%;
}

.text-pdpa {
  text-align: center;
  font-size: 14px;
}
@media only screen and (max-width: 960px) {
  h1 {
    display: none;
  }
}

@media only screen and (max-width: 960px) {
  .hide {
    display: none;
  }
}
</style>
